var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestVisitsProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#D35933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1641 47.9017C36.0584 47.017 44.2228 40.1291 46.9894 30.9055L28.4858 12.4019L26.168 18.972L13.333 35.0707L26.1641 47.9017Z",
    fill: "#B54324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 24.5388C34.6664 22.7684 33.2313 21.3335 31.4611 21.3335H16.5385C14.7681 21.3333 13.333 22.7685 13.333 24.5388V35.0707H34.6664V24.5388Z",
    fill: "#386895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6668 24.5388C34.6668 22.7684 33.2317 21.3335 31.4615 21.3335H23.9463V35.0709H34.6668V24.5388Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 24.0001C27.6816 24.0001 30.6663 21.0153 30.6663 17.3334C30.6663 13.6515 27.6816 10.6667 23.9997 10.6667C20.3178 10.6667 17.333 13.6515 17.333 17.3334C17.333 21.0153 20.3178 24.0001 23.9997 24.0001Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 10.6667C23.982 10.6667 23.9642 10.6681 23.9463 10.6681V23.9987C23.9642 23.9988 23.982 24 24.0001 24C27.682 24 30.6668 21.0152 30.6668 17.3333C30.6668 13.6514 27.682 10.6667 24.0001 10.6667Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 40.0001C37.6119 40.0001 39.9997 37.6122 39.9997 34.6667C39.9997 31.7212 37.6119 29.3334 34.6664 29.3334C31.7208 29.3334 29.333 31.7212 29.333 34.6667C29.333 37.6122 31.7208 40.0001 34.6664 40.0001Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.333 34.1819H35.1511V32C35.1511 31.7322 34.9341 31.5151 34.6662 31.5151C34.3984 31.5151 34.1814 31.7322 34.1814 32V34.1819H31.9995C31.7317 34.1819 31.5146 34.3989 31.5146 34.6667C31.5146 34.9346 31.7317 35.1516 31.9995 35.1516H34.1814V37.3334C34.1814 37.6013 34.3984 37.8183 34.6662 37.8183C34.9341 37.8183 35.1511 37.6013 35.1511 37.3334V35.1516H37.333C37.6008 35.1516 37.8178 34.9346 37.8178 34.6667C37.8178 34.3989 37.6008 34.1819 37.333 34.1819Z",
    fill: "#273B7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestVisitsProfile);
export default __webpack_public_path__ + "static/media/testVisitsProfile.b41a7ab2184c7e4ed17aa6708eb9d15f.svg";
export { ForwardRef as ReactComponent };